import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Settings } from 'lucide-react';
import LocationsConfig from '@/components/config/LocationsConfig';
import RoomsConfig from '@/components/config/RoomsConfig';
import ServicesConfig from '@/components/config/ServicesConfig';
import StaffConfig from '@/components/config/StaffConfig';
import SchedulesConfig from '@/components/config/SchedulesConfig';

const Configuration = ({ user }) => {
  return (
    <div className="p-6" data-testid="configuration-page">
      <div className="mb-6">
        <div className="flex items-center space-x-3">
          <Settings className="text-[#C9A961]" size={32} />
          <div>
            <h1 className="text-3xl font-semibold text-[#2C2C2C]">Configuración</h1>
            <p className="text-[#6B6B6B] mt-1">Administra locales, salas, servicios y equipo</p>
          </div>
        </div>
      </div>

      <Tabs defaultValue="locations" className="w-full">
        <TabsList className="grid w-full grid-cols-5 mb-6">
          <TabsTrigger value="locations">Locales</TabsTrigger>
          <TabsTrigger value="rooms">Salas</TabsTrigger>
          <TabsTrigger value="services">Servicios</TabsTrigger>
          <TabsTrigger value="staff">Equipo</TabsTrigger>
          <TabsTrigger value="schedules">Horarios</TabsTrigger>
        </TabsList>

        <TabsContent value="locations">
          <LocationsConfig />
        </TabsContent>

        <TabsContent value="rooms">
          <RoomsConfig />
        </TabsContent>

        <TabsContent value="services">
          <ServicesConfig />
        </TabsContent>

        <TabsContent value="staff">
          <StaffConfig />
        </TabsContent>

        <TabsContent value="schedules">
          <SchedulesConfig />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Configuration;
